<script setup lang="ts">
defineProps<{
  title: string;
  items: { label: string; description: string; to: string }[];
}>();
</script>

<template>
  <section>
    <div class="flex items-end justify-between gap-4 border-b border-brand-100 pb-4">
      <div>
        <p class="text-xs font-bold uppercase tracking-[0.14em] text-brand-600">
          Next steps
        </p>
        <h2 class="mt-2 text-2xl font-bold text-brand-900">
          {{ title }}
        </h2>
      </div>
      <span
        class="hidden text-sm font-medium text-slate-500 sm:block"
        aria-hidden="true"
      >
        Keep exploring
      </span>
    </div>
    <ul class="mt-5 grid gap-4 sm:grid-cols-2">
      <li
        v-for="(item, index) in items"
        :key="item.to"
      >
        <NuxtLink
          :to="item.to"
          class="group flex h-full items-start justify-between gap-4 rounded-2xl border border-slate-200 border-l-4 border-l-brand-200 bg-white p-5 shadow-[var(--shadow-card)] transition-colors hover:border-brand-300 hover:border-l-brand-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600"
        >
          <span>
            <span class="mb-3 block text-xs font-bold tracking-[0.12em] text-brand-700">
              {{ String(index + 1).padStart(2, '0') }}
            </span>
            <span class="font-semibold text-brand-800 group-hover:text-brand-600">
              {{ item.label }}
            </span>
            <span class="mt-2 block text-sm leading-6 text-slate-600">
              {{ item.description }}
            </span>
          </span>
          <UIcon
            name="i-heroicons-arrow-up-right-20-solid"
            class="mt-1 size-5 shrink-0 text-brand-700 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
            aria-hidden="true"
          />
        </NuxtLink>
      </li>
    </ul>
  </section>
</template>
